
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import WhyNexxSection from '@/components/WhyNexxSection';
import NetworkSection from '@/components/NetworkSection';
import TestimonialsSection from '@/components/TestimonialsSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';
import SEOMetadata from '@/components/SEOMetadata';

const Index = () => {
  return (
    <>
      <SEOMetadata
        title="NEXX TELECOM | Premium Data Center & Network Infrastructure Solutions"
        description="NEXX TELECOM provides premium data center solutions, VPN services, residential proxies, VPS servers, and network infrastructure for businesses worldwide. Expert colocation and connectivity solutions."
        keywords="data center solutions, VPN services, residential proxies, VPS servers, network infrastructure, colocation, connectivity solutions, NEXX TELECOM"
        ogTitle="NEXX TELECOM | Premium Infrastructure Solutions"
        ogDescription="Premium data center solutions, VPN services, and network infrastructure for businesses worldwide. Expert colocation and connectivity solutions."
        canonical="https://nexx.net"
      />
      <div className="min-h-screen">
      <Header />
      <main role="main">
        {/* Hero Section with Primary Keywords */}
        <section aria-label="Customized Data Center Solutions">
          <HeroSection />
        </section>
        
        {/* Why Choose NEXX Section */}
        <section aria-label="Why Choose NEXX TELECOM for Network Infrastructure">
          <WhyNexxSection />
        </section>
        
        {/* Network Infrastructure Section */}
        <section aria-label="Network Infrastructure and Data Center Services">
          <NetworkSection />
        </section>
        
        {/* Customer Testimonials */}
        <section aria-label="Customer Reviews and Testimonials">
          <TestimonialsSection />
        </section>
        
        {/* Contact Information */}
        <section aria-label="Contact NEXX TELECOM for VPN and Proxy Services">
          <ContactSection />
        </section>
      </main>
      <Footer />
      
      {/* Hidden SEO content for additional keyword coverage */}
      <div className="sr-only" aria-hidden="true">
        <h2>Comprehensive Data Center and Network Solutions</h2>
        <p>
          NEXX TELECOM specializes in customized data center solutions, offering high-speed VPN services, 
          secure proxy services, residential proxies, dedicated VPN solutions, bare metal servers, 
          virtual private servers (VPS), and network infrastructure optimization for businesses of all sizes.
        </p>
      </div>
    </div>
    </>
  );
};

export default Index;
